export enum LOCATION_DEPLOYMENT_STATUS {
  PLANNED = 'planned',
  PENDING = 'pending',
  ACTIVE = 'active',
  DECOMMISSIONED = 'decommissioned',
}
